// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file gps_tables.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Location, LocationJson } from "./location_pb";
import { file_location } from "./location_pb";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { PickupLocation, PickupLocationJson } from "./pickup_location_pb";
import { file_pickup_location } from "./pickup_location_pb";
import type { Truck, TruckJson } from "./truck_pb";
import { file_truck } from "./truck_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file gps_tables.proto.
 */
export const file_gps_tables: GenFile = /*@__PURE__*/
  fileDesc("ChBncHNfdGFibGVzLnByb3RvEglyYWNjb29uYWki3AYKB0dwc1N0b3ASCgoCaWQYASACKAQSOgoKY3JlYXRlZF9hdBgCIAIoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCmNyZWF0ZWRfYXQSOgoKdXBkYXRlZF9hdBgDIAIoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCnVwZGF0ZWRfYXQSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAQgAigEUhVvd25lcl9vcmdhbml6YXRpb25faWQSIAoLbG9jYXRpb25faWQYBSABKARSC2xvY2F0aW9uX2lkEi4KEnBpY2t1cF9sb2NhdGlvbl9pZBgGIAEoBFIScGlja3VwX2xvY2F0aW9uX2lkEiIKDGdwc19yb3V0ZV9pZBgHIAEoBFIMZ3BzX3JvdXRlX2lkEhoKCHRydWNrX2lkGAggAigEUgh0cnVja19pZBILCgNsb24YCSACKAESCwoDbGF0GAogAigBEiYKDm51bV9ncHNfcG9pbnRzGAsgAigEUg5udW1fZ3BzX3BvaW50cxIuChJhdmVyYWdlX3NwZWVkX2ttcGgYDCACKAFSEmF2ZXJhZ2Vfc3BlZWRfa21waBIlCgRtZXRhGA0gASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBIaCghzdGVwX2lkeBgOIAIoBFIIc3RlcF9pZHgSPgoMZ3BzX3N0YXJ0X2F0GA8gAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIMZ3BzX3N0YXJ0X2F0EjoKCmdwc19lbmRfYXQYECACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpncHNfZW5kX2F0Eh8KBXRydWNrGBEgASgLMhAucmFjY29vbmFpLlRydWNrEkcKEm93bmVyX29yZ2FuaXphdGlvbhgSIAEoCzIXLnJhY2Nvb25haS5Pcmdhbml6YXRpb25SEm93bmVyX29yZ2FuaXphdGlvbhIlCghsb2NhdGlvbhgTIAEoCzITLnJhY2Nvb25haS5Mb2NhdGlvbhJDCg9waWNrdXBfbG9jYXRpb24YFCABKAsyGS5yYWNjb29uYWkuUGlja3VwTG9jYXRpb25SD3BpY2t1cF9sb2NhdGlvbiI/CgtHcHNTdG9wTGlzdBIwCglncHNfc3RvcHMYASADKAsyEi5yYWNjb29uYWkuR3BzU3RvcFIJZ3BzX3N0b3BzIoMDCghHcHNSb3V0ZRIKCgJpZBgBIAIoBBI6CgpjcmVhdGVkX2F0GAIgAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKY3JlYXRlZF9hdBI6Cgp1cGRhdGVkX2F0GAMgAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKdXBkYXRlZF9hdBI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYBCACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIlCgRtZXRhGAUgASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBI+CgxncHNfc3RhcnRfYXQYBiACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgxncHNfc3RhcnRfYXQSOgoKZ3BzX2VuZF9hdBgHIAIoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBSCmdwc19lbmRfYXQSGgoIdHJ1Y2tfaWQYCCACKARSCHRydWNrX2lkQgZaBC4vcGI", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_location, file_organization, file_pickup_location, file_truck]);

/**
 * @generated from message raccoonai.GpsStop
 */
export type GpsStop = Message<"raccoonai.GpsStop"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 3 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 location_id = 5 [json_name = "location_id"];
   */
  locationId: bigint;

  /**
   * @generated from field: optional uint64 pickup_location_id = 6 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional uint64 gps_route_id = 7 [json_name = "gps_route_id"];
   */
  gpsRouteId: bigint;

  /**
   * @generated from field: required uint64 truck_id = 8 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: required double lon = 9;
   */
  lon: number;

  /**
   * @generated from field: required double lat = 10;
   */
  lat: number;

  /**
   * @generated from field: required uint64 num_gps_points = 11 [json_name = "num_gps_points"];
   */
  numGpsPoints: bigint;

  /**
   * @generated from field: required double average_speed_kmph = 12 [json_name = "average_speed_kmph"];
   */
  averageSpeedKmph: number;

  /**
   * JSON stored as string
   *
   * @generated from field: optional google.protobuf.Struct meta = 13;
   */
  meta?: JsonObject;

  /**
   * @generated from field: required uint64 step_idx = 14 [json_name = "step_idx"];
   */
  stepIdx: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_start_at = 15 [json_name = "gps_start_at"];
   */
  gpsStartAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_end_at = 16 [json_name = "gps_end_at"];
   */
  gpsEndAt?: Timestamp;

  /**
   * @generated from field: optional raccoonai.Truck truck = 17;
   */
  truck?: Truck;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 18 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: optional raccoonai.Location location = 19;
   */
  location?: Location;

  /**
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 20 [json_name = "pickup_location"];
   */
  pickupLocation?: PickupLocation;
};

/**
 * @generated from message raccoonai.GpsStop
 */
export type GpsStopJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 3 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 location_id = 5 [json_name = "location_id"];
   */
  location_id?: string;

  /**
   * @generated from field: optional uint64 pickup_location_id = 6 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional uint64 gps_route_id = 7 [json_name = "gps_route_id"];
   */
  gps_route_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 8 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: required double lon = 9;
   */
  lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double lat = 10;
   */
  lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required uint64 num_gps_points = 11 [json_name = "num_gps_points"];
   */
  num_gps_points?: string;

  /**
   * @generated from field: required double average_speed_kmph = 12 [json_name = "average_speed_kmph"];
   */
  average_speed_kmph?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * JSON stored as string
   *
   * @generated from field: optional google.protobuf.Struct meta = 13;
   */
  meta?: StructJson;

  /**
   * @generated from field: required uint64 step_idx = 14 [json_name = "step_idx"];
   */
  step_idx?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_start_at = 15 [json_name = "gps_start_at"];
   */
  gps_start_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_end_at = 16 [json_name = "gps_end_at"];
   */
  gps_end_at?: TimestampJson;

  /**
   * @generated from field: optional raccoonai.Truck truck = 17;
   */
  truck?: TruckJson;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 18 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: optional raccoonai.Location location = 19;
   */
  location?: LocationJson;

  /**
   * @generated from field: optional raccoonai.PickupLocation pickup_location = 20 [json_name = "pickup_location"];
   */
  pickup_location?: PickupLocationJson;
};

/**
 * Describes the message raccoonai.GpsStop.
 * Use `create(GpsStopSchema)` to create a new message.
 */
export const GpsStopSchema: GenMessage<GpsStop, {jsonType: GpsStopJson}> = /*@__PURE__*/
  messageDesc(file_gps_tables, 0);

/**
 * @generated from message raccoonai.GpsStopList
 */
export type GpsStopList = Message<"raccoonai.GpsStopList"> & {
  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 1 [json_name = "gps_stops"];
   */
  gpsStops: GpsStop[];
};

/**
 * @generated from message raccoonai.GpsStopList
 */
export type GpsStopListJson = {
  /**
   * @generated from field: repeated raccoonai.GpsStop gps_stops = 1 [json_name = "gps_stops"];
   */
  gps_stops?: GpsStopJson[];
};

/**
 * Describes the message raccoonai.GpsStopList.
 * Use `create(GpsStopListSchema)` to create a new message.
 */
export const GpsStopListSchema: GenMessage<GpsStopList, {jsonType: GpsStopListJson}> = /*@__PURE__*/
  messageDesc(file_gps_tables, 1);

/**
 * @generated from message raccoonai.GpsRoute
 */
export type GpsRoute = Message<"raccoonai.GpsRoute"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 3 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * JSON stored as string
   *
   * @generated from field: optional google.protobuf.Struct meta = 5;
   */
  meta?: JsonObject;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_start_at = 6 [json_name = "gps_start_at"];
   */
  gpsStartAt?: Timestamp;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_end_at = 7 [json_name = "gps_end_at"];
   */
  gpsEndAt?: Timestamp;

  /**
   * @generated from field: required uint64 truck_id = 8 [json_name = "truck_id"];
   */
  truckId: bigint;
};

/**
 * @generated from message raccoonai.GpsRoute
 */
export type GpsRouteJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 2 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp updated_at = 3 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * JSON stored as string
   *
   * @generated from field: optional google.protobuf.Struct meta = 5;
   */
  meta?: StructJson;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_start_at = 6 [json_name = "gps_start_at"];
   */
  gps_start_at?: TimestampJson;

  /**
   * @generated from field: required google.protobuf.Timestamp gps_end_at = 7 [json_name = "gps_end_at"];
   */
  gps_end_at?: TimestampJson;

  /**
   * @generated from field: required uint64 truck_id = 8 [json_name = "truck_id"];
   */
  truck_id?: string;
};

/**
 * Describes the message raccoonai.GpsRoute.
 * Use `create(GpsRouteSchema)` to create a new message.
 */
export const GpsRouteSchema: GenMessage<GpsRoute, {jsonType: GpsRouteJson}> = /*@__PURE__*/
  messageDesc(file_gps_tables, 2);

